import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  GET_BA_DATA, GET_BA_DATA_INVOICE, LATE_FEE, GET_BA_DATA_INVOICE_BY_SITE, GET_CLIENT_ORDERS
} from './type';

  export const getSiteList = () => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.dashboardSiteListing}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_BA_DATA, payload: data.response.data });
      return data.response.data;
    }
  };

  export const getInvoiceList = (email,key,invoiceType) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.dashboardInvoiceListing}?email=${email}&key=${key}&invoiceType=${invoiceType}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_BA_DATA_INVOICE, payload: data.response.data });
      return data.response.data.data;
    }
  };

  export const saveInvoiceData = (data,type) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.brandActivation.dashboardSetInvoiceData
    );
    if (res?.data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  };

  export const getCSV = (emails) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.getCSV}?emails=${emails}`
    );
    if (res) {
      const { data } = res;
      return data;
    }
    return false;
  };

  export const getLateFee = (invoice_id) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.getLateFee}?invoice_id=${invoice_id}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: LATE_FEE, payload: data.response.data });
      return data.response.data;
    }
    return false;
  };

  export const setInstallmentFee = (data) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      data,
      `${Config.brandActivation.setInstallmentFee}`
    );
    if (res?.data?.response?.status === 'Success') {
      return {"status": true, "message": res?.data?.response?.data};
    } else {
      return {"status": false, "message": res?.data?.response?.data};
    }
  };

  export const getInvoiceListBySiteNumber = (email,siteNumber,clientId) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.invoicesBySiteNumber}?email=${email}&siteNumber=${siteNumber}&clientId=${clientId}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_BA_DATA_INVOICE_BY_SITE, payload: data.response.data });
      // console.log('dropdown', data.response.data);
      return data.response.data;
    }
  };

  export const clientOrderListing = (page=1) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.getClientOrdersList}?page=${page}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: GET_CLIENT_ORDERS, payload: data.response.data });
      return data.response.data;
    }
  };